import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { isPaidTier, normalizeTier } from '../utils/supabaseProfile';

/**
 * Video-creation routes.
 * Access is based on plan, not a one-time session payment flag:
 * - free: always allowed (1 video/month enforced elsewhere)
 * - oneoff / subscription / premium: paid — allowed
 */
const ProtectedRoute = ({ children }) => {
  const { subscriptionTier } = useAppContext();
  const tier = normalizeTier(subscriptionTier);

  if (tier === 'free' || isPaidTier(tier)) {
    return children;
  }

  return <Navigate to="/subscription" replace />;
};

export default ProtectedRoute;
